import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box } from "@mantine/core";

import MainNavigation from "../components/navigation/MainNavigation";
import Footer from "../components/common/Footer/Footer";
import LocationCompletionModal from "../components/common/LocationCompletionModal";
import { isAdminPanelRoute } from "../admin/navigation/adminNavigation";
import AdminLayoutShell from "../admin/navigation/AdminLayoutShell";
import "../admin/navigation/AdminShell.css";

function RootLayout() {
  const authState = useSelector((state) => state.auth);
  const loggedInUser = authState.user;
  const location = useLocation();
  const adminPanelRoute = isAdminPanelRoute(location.pathname, authState);
  const adminLoginRoute = location.pathname === "/admin-login";

  if (adminPanelRoute) {
    return (
      <Box
        className="admin-root-layout"
        style={{ minHeight: "100vh", padding: 0 }}
      >
        <AdminLayoutShell>
          <Outlet />
        </AdminLayoutShell>
      </Box>
    );
  }

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      {!adminLoginRoute && <MainNavigation />}
      {loggedInUser && !adminLoginRoute && <LocationCompletionModal />}
      <Box component="main" style={{ flex: 1, padding: 0 }}>
        <Outlet />
      </Box>
      {!adminLoginRoute && <Footer />}
    </Box>
  );
}

export default RootLayout;
